import { handleHttpResponse } from "../../utils/http_response_utils";

export const getActiveTasks = async (cluster) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-active-tasks?" + new URLSearchParams({ cluster: cluster }), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const deleteTask = async (taskArn, cluster) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/stop-task", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      taskArn: taskArn,
      cluster: cluster,
      userId: sessionStorage.getItem("user-id"),
    }),
  });
  return await handleHttpResponse(response);
};

export const initScraperTask = async (
  companyNames,
  scraperVersion,
  startDate,
  endDate,
  scraperClass,
  options,
  database,
  rerun
) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/init-scraper-task", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      companyNames: companyNames,
      scraperVersion: scraperVersion,
      startDate: startDate,
      endDate: endDate,
      scraperClass: scraperClass,
      options: options,
      database: database,
      rerun: rerun,
      userId: sessionStorage.getItem("user-id"),
    }),
  });
  return await handleHttpResponse(response);
};

export const initJsonCompetitorTask = async (companyName) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/init-json-export-task", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      scraperClass: "Competitor",
      companyName: companyName,
      userId: sessionStorage.getItem("user-id"),
    }),
  });
  return await handleHttpResponse(response);
};

export const initJsonClientTask = async (companyName, year, quarter) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/init-json-export-task", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      scraperClass: "Client",
      companyName: companyName,
      year: year,
      quarter: quarter,
      userId: sessionStorage.getItem("user-id"),
    }),
  });
  return await handleHttpResponse(response);
};

export const initAuto4clientTask = async (
  companyName,
  startDate,
  endDate,
  overwriteExistingDBRows,
  includePreviouslyClassified,
  competitiveAnalysis,
  dataName,
  platforms
) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/init-auto4client-task", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      companyName: companyName,
      platforms: platforms,
      startDate: startDate,
      endDate: endDate,
      competitiveAnalysis: competitiveAnalysis,
      includePreviouslyClassified: includePreviouslyClassified,
      overwriteExistingDBRows: overwriteExistingDBRows,
      dataName: dataName,
      userId: sessionStorage.getItem("user-id"),
    }),
  });
  return await handleHttpResponse(response);
};

export const initGeocoderTask = async (platforms, startDate, endDate) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/init-geocoder-task", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      platforms: platforms,
      startDate: startDate,
      endDate: endDate,
      userId: sessionStorage.getItem("user-id"),
    }),
  });
  return await handleHttpResponse(response);
};
